import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const ConsultaBaixaList = props => <DefaultDataTable data={props} />;
